export class OpptyHccValuationReportItem {
    PayerID?: number;
    PayerName?: string;
    StateID?: number;
    StatusID?: number;
    StatusOrder?: number;
    Status?: string;
    TotalCount?: number;
    HCCCount?: number;
    Valuation?: number;

    constructor(init?: Partial<OpptyHccValuationReportItem>) {
        Object.assign(this, init);
    }
}
